export interface LoaderProps {
  heightValue?: number
  type?: LoaderType
}

export enum LoaderType {
  'RELATIVE',
  'ABSOLUTE'
}
